import { View } from 'react-native';
import { openDailyGoal } from '@/utils/dailyGoalUtil';
import { Icon, IconName } from '@/components/Icon';
import { useStoreState } from '@/stores/store';
import { Patient } from '@/stores/store.types';
import { styles } from './styles';

type PROPS = {
  stars: number;
  patient?: Patient;
};

// Here we access the 'dailyPracticeDurationGoal' differently between the patient app & the therapist app. We can access 'dailyPracticeDurationGoal' via the activePatient global state in the patient app. For the therapist app, we can access it via the downloadPatients global state in the therapist app which is then passed to as a prop to StarsDialog.

export const StarsDialog = ({ stars, patient }: PROPS) => {
  const dailyPracticeDurationGoal = useStoreState(
    (store) => store.activePatient?.dailyPracticeDurationGoal,
  );

  const dailyGoal = patient
    ? patient.dailyPracticeDurationGoal
    : dailyPracticeDurationGoal;
  const tagesziel = Math.floor(dailyGoal ? dailyGoal / 10 : 0);

  const generateStars = () => {
    const starsJSX = openDailyGoal(tagesziel, stars ?? 0);
    return starsJSX.map(({ name, key, ...props }) => (
      <Icon key={key} {...props} name={name as IconName} />
    ));
  };

  return <View style={styles.container}>{generateStars()}</View>;
};
